// extracted by mini-css-extract-plugin
export var con = "landing-module--con--27mEc";
export var header = "landing-module--header--1Ks21";
export var logo = "landing-module--logo--4Qmwt";
export var login = "landing-module--login--XPGYp";
export var body = "landing-module--body--2_5p6";
export var float = "landing-module--float--tEpIN";
export var signUp = "landing-module--signUp--3Xqv6";